import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { FaHandshake, FaCheckCircle } from 'react-icons/fa';


const ThankYouPage = () => {

  useEffect(() => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead');
    }
  }, []);
  
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-violet-200 via-white to-violet-100 items-center justify-center p-6">

       <Helmet>

        <script>
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
          `}
        </script>


        <noscript>
          {`<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=1183772839914578&ev=PageView&noscript=1"
          />`}
        </noscript>
      </Helmet>
      <div className="w-full md:w-1/2 backdrop-blur-lg bg-white/30 rounded-2xl p-10 text-center border border-white/30 shadow-2xl">
        {/* Icon with glass effect */}
        <div className="flex justify-center mb-6">
          <div className="backdrop-blur-md bg-white/20 p-5 rounded-full border border-white/30 shadow-lg">
            <FaHandshake className="text-violet-600 text-8xl " />
          </div>
        </div>



        {/* Content */}
        <div className="space-y-4">
          <h1 className="text-3xl md:text-5xl py-10 font-extrabold bg-gradient-to-r from-purple-500 to-cyan-400 text-transparent  bg-clip-text">
            Thank you for your interest
          </h1>

          <div className=" p-4 rounded-xl">
            <h3 className=" text-sm md:text-xl text-violet-800 flex items-center justify-center gap-2">
              <FaCheckCircle className="text-violet-500" />
              We will get back to you shortly!
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;

